import { createSelector } from "reselect";

const getShortlist = state => state.shortlist;

export const getShortlistData = createSelector(
  getShortlist,
  shortlistData => {
    const { shortlist, modalTypeId, isLoading, vehicleId } = shortlistData;
    return {
      modalTypeId,
      shortlist,
      isLoading,
      vehicleId,
    };
  },
);
